import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Header from "./main/components/Header/header";
import Introduction from "./main/components/introduction/intro";
import Img_1 from "./main/components/img_1/img_1";
import Enturf from "./main/components/enturf/enturf";
import Img_2 from "./main/components/img_2/img_2";
import Enturf_wrk from "./main/components/enturf_wrk/enturf_wrk";
import Community_img from "./main/components/community_img/community_img";
import Join_community from "./main/components/join_community/j_community";
import Enturf_logo from "./main/components/enturf_logo/logo";
import PrivacyPolicy from "./main/PrivacyPolicy";

function HomePage() {
  return (
    <>
      <Introduction />
      <Img_1 />
      <Enturf />
      <Img_2 />
      <Enturf_wrk />
      <Community_img />
      <Join_community />
      <Enturf_logo />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="container-fluid">
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;